<template>
	<div>
		<!-- logo 时间 -->
		<q-head></q-head>
		<!-- banner -->
		<qBanner></qBanner>
		
		
		
		<!-- 导航 3列的 -->
		<div class="nav-list" v-if="!navList2">
			<ul>
				<li>
					<a @click="pageClick('检验报告')">
						<div class="icon">
							<img src="../../assets/icon/icon1.png" >
						</div>
						<h3>检验报告</h3>
						<p>
							检验报告
						</p>
					</a>
				</li>
				<li class="yellow">
					<a @click="pageClick('门诊缴费')">
						<div class="icon">
							<img src="../../assets/icon/icon2.png" >
						</div>
						<h3>门诊缴费</h3>
						<p>
							门诊缴费
						</p>
					</a>
				</li>
				<li>
					<a @click="pageClick('当日挂号')">
						<div class="icon">
							<img src="../../assets/icon/icon3.png" >
						</div>
						<h3>当日挂号</h3>
						<p>
							当日挂号
						</p>
					</a>
				</li>
				<li class="yellow">
					<a @click="pageClick('住院预缴')">
						<div class="icon">
							<img src="../../assets/icon/icon4.png" >
						</div>
						<h3>住院预缴</h3>
						<p>
							住院预缴
						</p>
					</a>
				</li>
				<li>
					<a @click="pageClick('发票打印')">
						<div class="icon">
							<img src="../../assets/icon/icon5.png" >
						</div>
						<h3>发票打印</h3>
						<p>
							发票打印
						</p>
					</a>
				</li>
				<li>
					<a href="#/searchIndex">
						<div class="icon">
							<img src="../../assets/icon/icon6.png" >
						</div>
						<h3>综合查询</h3>
						<p>
							综合查询
						</p>
					</a>
				</li>
				<li class="green">
					<a @click="pageClick('预约挂号')">
						<div class="icon">
							<img src="../../assets/icon/icon7.png" >
						</div>
						<h3>预约挂号</h3>
						<p>
							预约挂号
						</p>
					</a>
				</li>
				<li>
					<a @click="pageClick('预约取号')">
						<div class="icon">
							<img src="../../assets/icon/icon8.png" >
						</div>
						<h3>预约取号</h3>
						<p>
							预约取号
						</p>
					</a>
				</li>
				<li class="green">
					<a @click="pageClick('自助核酸')">
						<div class="icon">
							<img src="../../assets/icon/icon9.png" >
						</div>
						<h3>自助核酸</h3>
						<p>
							自助核酸
						</p>
					</a>
				</li>
				<li class="col2 green">
					<a>
						<div class="icon">
							<img src="../../assets/icon/icon10c.png" >
						</div>
						<h3>电子健康卡发码</h3>
						<p>
							电子健康卡发码
						</p>
					</a>
				</li>
				<li class="col2">
					<a>
						<div class="icon">
							<img src="../../assets/icon/icon11c.png" >
						</div>
						<h3>就医评价</h3>
						<p>
							就医评价
						</p>
					</a>
				</li>
				
			</ul>
		</div>
		
		<!-- 导航 2列的 -->
		<div class="nav-list" v-else>
			<ul>
				<li class="col2">
					<a @click="pageClick(1)">
						<div class="icon">
							<img src="../../assets/icon/icon1c.png" >
						</div>
						<h3>检验报告</h3>
						<p>
							检验报告
						</p>
					</a>
				</li>
				<li class="col2 yellow">
					<a @click="pageClick(2)">
						<div class="icon">
							<img src="../../assets/icon/icon2c.png" >
						</div>
						<h3>门诊缴费</h3>
						<p>
							门诊缴费
						</p>
					</a>
				</li>
				<li class="col2">
					<a @click="pageClick(3)">
						<div class="icon">
							<img src="../../assets/icon/icon3c.png" >
						</div>
						<h3>当日挂号</h3>
						<p>
							当日挂号
						</p>
					</a>
				</li>
				<li class="col2 yellow">
					<a @click="pageClick(4)">
						<div class="icon">
							<img src="../../assets/icon/icon4c.png" >
						</div>
						<h3>住院预缴</h3>
						<p>
							住院预缴
						</p>
					</a>
				</li>
				<li class="col2">
					<a @click="pageClick(5)">
						<div class="icon">
							<img src="../../assets/icon/icon5c.png" >
						</div>
						<h3>发票打印</h3>
						<p>
							发票打印
						</p>
					</a>
				</li>
				
				<li class="col2">
					<a @click="pageClick(6)">
						<div class="icon">
							<img src="../../assets/icon/icon6c.png" >
						</div>
						<h3>综合查询</h3>
						<p>
							综合查询
						</p>
					</a>
				</li>
				<li class="green">
					<a @click="pageClick(7)">
						<div class="icon">
							<img src="../../assets/icon/icon7.png" >
						</div>
						<h3>预约挂号</h3>
						<p>
							预约挂号
						</p>
					</a>
				</li>
				<li>
					<a @click="pageClick(8)">
						<div class="icon">
							<img src="../../assets/icon/icon8.png" >
						</div>
						<h3>预约取号</h3>
						<p>
							预约取号
						</p>
					</a>
				</li>
				<li class="">
					
					<a href="javascript:;">
						<div class="next">下一页</div>
					</a>
				</li>
				
				
			</ul>
		</div>
		
		
		
		<div class="footer fc-bet">
			<div>设备编号：1654FAS354    软件版本号：V2.1.0</div>
			<div>©2021  版权所有  软件公司名称</div>
		</div>
		<!-- 去选择读卡 -->
		<q-read :title="readCardTitle" :time="88" v-if="toReadCard" @close-read="closeRead"></q-read>
		
		<loading msg="loading中" v-if="loadingShow"></loading>
	
	</div>
</template>

<script>

	import qHead from '@/components/q-head/q-head.vue';
	import qBanner from '@/components/q-head/q-banner.vue';
	import qRead from '@/components/q-read/q-read.vue';
	import loading from '@/components/loading/loading.vue';
	
	
	export default {
		components: {
			qHead,qBanner,qRead,loading
		},
		data() {
			return {
				//2列导航
				navList2:false,
				// 去读卡
				toReadCard:false,
				readCardTitle:"门诊缴费",
				loadingShow:true,
			}
		},
		mounted() {
			var that=this;
			setTimeout(()=>{
				that.loadingShow=false
			},3000)
		},
		methods:{
			pageClick(txt){
				this.toReadCard=true
				this.readCardTitle=txt
			},
			closeRead(data){
				console.log(data)
				this.toReadCard=data
			},
			
			keyInput(data){
				console.log("键盘返回值"+data)
				this.showKeyboard=false
			},
			keyInputClose(data){
				console.log("键盘返回"+data)
				this.showKeyboard=false
			}
			
		}
		
		
	}
</script>

<style scoped lang="less">
	.footer{
		position: absolute;
		left: 38px;
		right: 38px;
		font-size: 18px;
		bottom: 0;
		
		font-weight: 400;
		color: #000000;
		bottom: 6px;
		line-height: 38px;
		opacity: 0.5;
	}
.nav-list{
	ul{
		display: flex;
		padding-left: 75px;
		padding-top: 20px;
		flex-wrap: wrap;
	}
	li{
		width: 289px;
		height: 244px;
		background: #50A2FF;
		border-radius: 20px;
		margin-right: 36px;
		margin-bottom: 29px;
	}
	a{
		display: block;
		height: 244px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		position: relative;
	}
	.icon{
		width: 108px;
		height: 108px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	h3{
		font-size: 30px;
		color: #fff;
		line-height: 50px;
	}
	.next{
		font-size: 46px;
		color: #fff;
	}
	p{
		font-size: 22px;
		line-height: 30px;
		font-weight: 500;
		color: #FFFFFF;
		
		opacity: 0.5;
	}
	.col2{
		width: 451px;
		a{
			display: block;
		}
		h3{
			padding-top: 20px;
			margin-bottom: 10px;
		}
		h3,p{
			padding-left: 34px;
		}
		.icon{
			position: absolute;
			right: 30px;
			top: 30px;
			background-color: #fff;
			border-radius: 150px;
		}
	}
	.yellow{
		background: #FF9537;
	}
	.green{
		background: #00B468;
	}
}

</style>
